import { render } from "./AppUpdateBanner.vue?vue&type=template&id=64a059e6&scoped=true"
import script from "./AppUpdateBanner.vue?vue&type=script&lang=js"
export * from "./AppUpdateBanner.vue?vue&type=script&lang=js"

import "./AppUpdateBanner.vue?vue&type=style&index=0&id=64a059e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a059e6"]])

export default __exports__